module.exports = __webpack_public_path__ + "img/banner.83d7bdf7.png";